import { Box, Checkbox, MenuItem, Typography } from "@mui/material";
import { ColorPallet } from "../../utils/colorPallet";
import ProfileImage from "../../assets/images/profileImage.svg";
import UserPermission from "../common/UserPermission";
import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getStaffPerById } from "../../features/staff/staffSlice";
import { Roles } from "../../utils/constants";
import NoDataMessage from "../common/NoDataMessage";

interface IProps {
  item: any;
}
const StaffViewModal = ({ item }: IProps) => {
  const StaffRole =
    item?.role_id === Roles.PHARMACIST
      ? "Pharmacist"
      : item?.role_id === Roles.TECHNICIAN
      ? "Technician"
      : item?.role_id === Roles.ASSISTANT
      ? "Assistant"
      : item?.role_id === Roles.MANAGER
      ? "MANAGER"
      : item?.role_id === Roles.INTERN
      ? "Intern"
      : item?.role_id === Roles.STOCK_MANAGER
      ? "Stock Manager"
      : item?.role_id === Roles.CASHIER
      ? "Cashier"
      : "";

  const dispatch = useAppDispatch();
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const [allComponentsData, setAllComponentsData] = useState<any[]>([]);

  const getStaffPermissionsById = useCallback(() => {
    const obj: any = {
      staff_id: item?.id,
      pharmacy_id: pharmacyId,
    };
    dispatch(getStaffPerById(obj)).then((res: any) => {
      if (res?.payload?.success === true) {
        const data = Array.isArray(res?.payload?.data) ? res.payload.data : [];
        setAllComponentsData(data);
      } else {
        setAllComponentsData([]);
      }
    });
  }, [dispatch, item?.id, pharmacyId]);

  useEffect(() => {
    getStaffPermissionsById();
  }, [getStaffPermissionsById]);

  const {
    permissionsPayload: { data: staffPermissions },
  }: any = useAppSelector((state) => state.staff);

  const displayTablePermissions = (
    column: string,
    module_name: string,
    permissions: Array<any>
  ) => {
    const exists = permissions.some((item) => item.submodule === column);
    if (exists) {
      const isChecked = permissions.some((item) => item.submodule === column);

      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Checkbox
            style={{
              borderColor: "#C4C4C4",
              color: isChecked ? "#0055A8" : "#0055A8",
            }}
            checked={isChecked}
          />
        </Box>
      );
    } else {
      return (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <Checkbox
            style={{
              borderColor: "#C4C4C4",
              color: "#C4C4C4",
            }}
            checked={false}
            disabled
          />
        </Box>
      );
    }
  };

  return (
    <>
      <Box
        sx={{
          margin: 2,
          backgroundColor: ColorPallet.bgcolor,
          marginTop: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Box>
            <img style={{ width: "30px" }} src={ProfileImage} alt="Avatar" />
          </Box>
          <Box>
            <Typography variant="h6">{item?.name}</Typography>
            <Typography variant="body2">{item?.email}</Typography>
          </Box>
        </Box>

        <Box
          sx={{
            marginTop: "20px",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h6">Role</Typography>
            <Typography variant="body2">{StaffRole}</Typography>
          </Box>

          <Box
            sx={{
              height: { xs: "1px", sm: "30px" },
              width: { xs: "100%", sm: "1px" },
              backgroundColor: "#5C697C",
            }}
          ></Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h6">Phone #</Typography>
            <Typography variant="body2">{item?.contact_number}</Typography>
          </Box>

          <Box
            sx={{
              height: { xs: "1px", sm: "30px" },
              width: { xs: "100%", sm: "1px" },
              backgroundColor: "#5C697C",
            }}
          ></Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography variant="h6">Address</Typography>
            <Typography variant="body2">{item?.address}</Typography>
          </Box>
        </Box>
      </Box>

      {/** User Permissions */}

      {allComponentsData.length > 0 ? (
        <Box
          sx={{
            mx: 2,
          }}
        >
          <UserPermission
            displayTablePermissions={displayTablePermissions}
            allComponentsData={allComponentsData}
          />
        </Box>
      ) : (
        <NoDataMessage />
      )}
    </>
  );
};
export default StaffViewModal;
